/* eslint-disable react/no-danger */
import React, { useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getVariantResult } from "../state/selectors/general.selectors";
import isUserLoggedIn from "../common/helpers/isUserLoggedIn";

const AdminMessage = (props) => {
  const { varsomeConfig } = window;
  const { position, variantResult } = props;

  const hubspotBannerLoaded = useRef(false);
  const counter = useRef(0);

  if (!hubspotBannerLoaded.current) {
    if (varsomeConfig.hubspot_banner_visible) {
      if (window.hbspt) {
        // eslint-disable-next-line no-undef
        hbspt.cta.load(4384097, "398e7245-cb7b-4c74-b624-01fd7e90bef0", {});
        hubspotBannerLoaded.current = true;
      }
    } else {
      hubspotBannerLoaded.current = true;
    }
  }

  const msgs = varsomeConfig.admin_messages[position]
    ? varsomeConfig.admin_messages[position].map((message) => {
        counter.current += 1;
        return {
          ...message,
          content: { __html: message.message },
          id: counter.current,
        };
      })
    : null;

  if (variantResult) {
    let messagesToDisplay;
    if (msgs) {
      messagesToDisplay = msgs.map((message) => {
        if (message.visible === 3) return null;
        if (message.visible === 1 && isUserLoggedIn()) return null;
        if (message.visible === 2 && !isUserLoggedIn()) return null;
        return (
          <div className="row row-xs-top" key={message.id}>
            <div className="col-12 col-xs-12">
              <div className={`admin-message ${message.color}`}>
                {/* dangerouslySetInnerHTML is needed here because we display HTML  */}
                <span dangerouslySetInnerHTML={message.content} />
              </div>
            </div>
          </div>
        );
      });
    }

    if (position === "top") {
      return <div>{messagesToDisplay}</div>;
    }
  }

  return <div />;
};

AdminMessage.propTypes = {
  position: PropTypes.string,
  variantResult: PropTypes.shape({}),
};

AdminMessage.defaultProps = {
  position: null,
  variantResult: null,
};

const mapStateToProps = (state) => ({
  variantResult: getVariantResult(state),
});

export default connect(mapStateToProps, {})(AdminMessage);
